'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useQuery } from '@repo/tanstack/query';
export const useCmdkCompanies = (filter, search, t0) => {
  const $ = _c(10);
  const perPage = t0 === undefined ? 10 : t0;
  const api = useApi();
  let t1;
  if ($[0] !== search) {
    t1 = search.trim();
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.length >= 1;
  let t3;
  if ($[2] !== api.companies.listByType || $[3] !== filter || $[4] !== perPage || $[5] !== search) {
    t3 = api.companies.listByType.queryOptions({
      input: {
        perPage,
        search: search.trim()
      },
      path: {
        filter
      }
    });
    $[2] = api.companies.listByType;
    $[3] = filter;
    $[4] = perPage;
    $[5] = search;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = {
      enabled: t2,
      ...t3,
      staleTime: 30000
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return useQuery(t4);
};